import { Button } from "../button/Button";
import "./Badge.scss";

export interface BadgeProps {
  title: string;
  color: string;
  toUpperCase?: boolean; 
}

export const Badge = ({ title, color, toUpperCase = true}: BadgeProps) => {
  return (
        <Button
        className={["modified-badge", `bg--${color}`].join(" ")}
        title={toUpperCase ? title.toUpperCase() : title}       
        type="round"
        variant="secondary-two"
        size="small"
        />
    
  );
};
